<template>
  <div>
    <!-- <div class="mobile-app-downlod-area">
      <div v-show="showMobileAppDownload && !$store.state.app.hideMobileNav" class="mobile_app_download">
        <div class="d-flex align-items-center">
          <svg
            class="mr-20"
            xmlns="http://www.w3.org/2000/svg"
            width="17.678"
            height="17.678"
            viewBox="0 0 17.678 17.678"
            @click="showMobileAppDownload = false"
          >
            <g transform="translate(-100.146 -5.454)">
              <line x2="24" transform="translate(100.5 5.808) rotate(45)" fill="none" stroke="#a8a8a8" stroke-width="1" />
              <line
                x2="24"
                transform="translate(117.471 5.808) rotate(135)"
                fill="none"
                stroke="#a8a8a8"
                stroke-width="1"
              />
            </g>
          </svg>
          <div class="mobile_app_title d-flex align-items-center">
            <img class="mr-t" :src="$store.getters.brand.image_square" width="40" height="40">
            <h6 class="text-white mb-0 ml-2">
              {{ $store.getters.brand.site_title }} APP
            </h6>
          </div>
          <button
            class="btn btn_download text-white border-0 ml-auto"
            type="button"
            @click="goMobileAppDownload()"
          >
            {{ $t('Bao.download_now') }}
          </button>
        </div>
      </div>
    </div> -->
    <!-- <top-bar /> -->
    <div class="header-content">
      <header class="header_area">
        <div class="header_inner">
          <nav id="js_menu_area" class="menu_area d-flex">
            <div class="menu_wrapper overflow-auto menu_scroll d-flex">
              <div
                v-for="(type, key) in this.$store.getters.gameType"
                :key="key"
                class="menu_list"
                @mouseover="handleOver(key)"
                @mouseleave="handleLeave()"
              >
                <a href="#" class="menu_inner menu_dropdown dropdown-toggle">
                  <img class="icon_img" :src="type.image_pc_icon">
                  <div>{{ type.name }}</div>
                </a>
                <div class="menu_wrap">
                  <div class="menu_content">
                    <div class="container">
                      <ul class="col_3 d-grid align-items-start list-unstyled mb-0">
                        <li class="d-none d-lg-block">
                          <a class="menu_ad d-block" href="#">
                            <img
                              class="mw-100"
                              :src="$store.getters.permissionInfo.sport_promotion_image"
                              height="190"
                              alt=""
                            >
                          </a>
                        </li>
                        <li>
                          <ul class="menu_sub d-flex justify-content-center flex-wrap list-unstyled mb-0 menu_sub_row1" :class="{ 'one_colum': type.providers.length < 5}">
                            <li v-for="(item, sub_key) in type.providers.slice(0, 5)" :key="sub_key">
                              <a class="d-block" @click="goProvider(item)">
                                <img class="mw-100" :src="item.image" alt="">
                              </a>
                            </li>
                          </ul>
                          <ul class="menu_sub d-flex justify-content-start flex-wrap list-unstyled mb-0 menu_sub_row2">
                            <li v-for="(item, sub_key) in type.providers.slice(5, 20)" :key="sub_key">
                              <a class="d-block" @click="goProvider(item)">
                                <img class="mw-100" :src="item.image" alt="">
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li class="d-none d-lg-block">
                          <a class="menu_ad d-block" href="#">
                            <img
                              class="mw-100"
                              :src="$store.getters.permissionInfo.download_app_qr_code"
                              height="190"
                              alt=""
                            >
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <div v-if="$store.getters.permissionInfo.enable_sponsor" class="link_sponsor_area align-items-center">
            <template v-if="main_image.sponsor_menu !== undefined">
              <router-link :to="main_image.sponsor_menu[0].link" class="link_sponsor_block d-block">
                <ul class="link_sponsor_list d-flex list-unstyled mb-0">
                  <li v-for="(item, key) in main_image.sponsor_menu_mobile" :key="key">
                    <img class="mw-100" :src="item.image" width="24" height="24" alt="">
                  </li>
                </ul>
              </router-link>
            </template>
          </div>
          <div class="logo_area d-flex align-items-center">
            <router-link class="d-block flex-shrink-0" to="/index">
              <img class="img_logo d-flex mw-100" :src="$store.getters.brand.image" alt="">
            </router-link>
          </div>
          <div id="my-link" class="btn_scroll_area position-absolute">
            <button
              :class="['btn', 'btn_scroll', 'rounded-0', 'btn_scroll_left', 'js_btn_scroll_left', { 'disabled': slideLeftDisabled }]"
              type="button"
              @click="slideLeft"
            >
              <i class="icon-keyboard_arrow_left" />
            </button>
            <button
              :class="['btn', 'btn_scroll', 'rounded-0', 'btn_scroll_left', 'js_btn_scroll_right', { 'disabled': slideRightDisabled }]"
              type="button"
              @click="slideRight"
            >
              <i class="icon-keyboard_arrow_right" />
            </button>
          </div>
          <!-- mobile nav -->
          <div v-show="!$store.state.app.hideMobileNav" class="mobile_only mobile-nav">
            <ul class="mobile-nav-container">
              <li class="mobile-nav-item home">
                <div v-if="$route.path === '/index'" class="nav-home-on" @click="$router.push('/index')">
                  <img :src="require('@/assets/' + theme + '/img/mobile/tabbar/home_on.png')">
                </div>
                <div v-else class="nav-home-off">
                  <router-link to="/index">
                    <div class="mobile-nav-img" />
                    <p>{{ $t('Bao.home') }}</p>
                  </router-link>
                </div>
              </li>
              <li class="mobile-nav-item discount" :class="{ 'active': ($route.path === '/user/friend') }">
                <router-link :to="($store.getters.token) ? '/user/friend' : '/user/login'">
                  <div class="mobile-nav-img" style="width: 19px;">
                    <!-- <img src="img/mobile/tabbar/friend_off.png" alt="discount" /> -->
                  </div>
                  <p>{{ $t('Bao.promos') }}</p>
                </router-link>
              </li>

              <template v-if="$store.getters.urlInfo.websocketChatUrl">
                <li class="mobile-nav-item chat">
                  <a target="_blank" :href="getChatSrc()" @click="enterChat()">
                    <div class="mobile-nav-img">
                      <img :src="require('@/assets/' + theme + '/img/mobile/tabbar/chat_off.svg')" alt="discount">
                    </div>
                    <p>{{ $t('Bao.chat_room') }}</p>
                  </a>
                </li>
              </template>
              <template v-else>
                <li class="mobile-nav-item chat" :class="{ 'active': ($route.path === '/event') }">
                  <router-link to="/event">
                    <div class="mobile-nav-img">
                      <!-- <img :src="$store.getters.brand.image_square"> -->
                    </div>
                    <p>{{ $t('Bao.event') }}</p>
                  </router-link>
                </li>
              </template>

              <li class="mobile-nav-item topup" :class="{ 'active': ($route.path === '/payment/deposit') }">
                <router-link to="/payment/deposit">
                  <div class="mobile-nav-img">
                    <!-- <img :src="require('@/assets/' + theme + '/img/mobile/tabbar/topup_off.svg')" alt="discount"> -->
                  </div>
                  <p>{{ $t('Bao.deposit') }}</p>
                </router-link>
              </li>

              <li class="mobile-nav-item more">
                <div class="mobile-nav-img">
                  <!-- <img :src="require('@/assets/' + theme + '/img/mobile/tabbar/more_off.svg')" alt="discount"> -->
                </div>
                <p>{{ $t('Bao.more') }}</p>
              </li>
            </ul>
          </div>
          <!-- END OF mobile nav -->
          <ul class="sub_menu_area d-flex align-items-center list-unstyled mb-0">
            <li id="js_login_status" class="login_status" :class="{ 'login': $store.getters.token }">
              <div class="login_status_cont">
                <div v-if="$store.getters.token" class="login_status_wrap">
                  <div class="d-grid">
                    <div class="login_status_img position-relative cursor-pointer" @click="$router.push('/user')">
                      <img
                        class="rounded-circle mw-100"
                        :src="$store.getters.memberInfo.image"
                        width="32"
                        height="37"
                        alt=""
                      >
                      <small v-if="$store.state.user.unreadLetter" class="tips position-absolute rounded-circle" />
                    </div>
                    <span class="login_status_inner d-flex flex-column justify-content-center">
                      <h5 class="text-white mb-0 cursor-pointer" @click="$router.push('/user')">{{ $store.getters.name
                      }}</h5>
                      <ul class="login_status_info d-flex align-items-center list-unstyled mb-0">
                        <li class="d-flex">
                          <h6 class="login-money-text mb-0">
                            <!--eslint-disable-next-line-->
                            <span v-html="$options.filters['numberFormat']($store.getters.gold)" />
                          </h6>
                        </li>
                        <li class="d-flex mr-auto">
                          <button class="btn btn_reflash border-0 p-0" type="button" @click="refreshGold()">
                            <i class="icon-repeat d-flex text-white" />
                          </button>
                        </li>
                      </ul>
                    </span>
                    <div class="d-flex">
                      <button class="btn btn_stored_value border-0" @click="$router.push('/payment/deposit')">
                        <!--eslint-disable-next-line-->
                        <span v-html="deposit_word" />
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="login_status_btn" @click="goLogin()">
                  <div class="d-flex justify-content-center">
                    <button class="btn btn_login d-block" to="/user/login" tag="button">
                      <span>{{ $t('Bao.login') }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="sub_member_menu_wrap">
                <div class="sub_member_menu w-100">
                  <div class="sub_member_wrap">
                    <div class="sub_member_btn d-grid">
                      <button
                        class="btn btn_stored_value text-white"
                        type="button"
                        @click="$router.push('/payment/deposit')"
                      >
                        {{ $t('Bao.deposit') }}
                      </button>
                      <button
                        class="btn btn_withdraw text-white"
                        type="button"
                        @click="$router.push('/payment/withdrawal')"
                      >
                        {{ $t('Bao.withdrawal') }}
                      </button>
                    </div>
                    <ul class="sub_member_list list-unstyled mb-0">
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/user">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_person' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.personal') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/wallet">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_money' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.transaction-wallet') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/transaction">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_detail' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.transaction-index') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/game/bet">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_bet' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.game-bet-index') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/event/me">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_bonus' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.event-me') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/event">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_sale' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.event-index') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/user/letter">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_notify' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.letter-index') }}</span>
                          <div
                            v-if="$store.state.user.unreadLetter"
                            class="sub_member_num rounded-circle text-center text-white"
                          >
                            {{ $store.state.user.unreadLetter }}
                          </div>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/bank">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_money' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.bank_card') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/vip">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_vip' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.vip') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link class="d-flex align-items-center justify-content-between" to="/user/friend">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_recommend' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.user-friend') }}</span>
                        </router-link>
                      </li>
                      <li>
                        <a class="d-flex align-items-center justify-content-between lang-switch" href="#">
                          <picture class="mw-100">
                            <source media="(min-width: 992px)" srcset="@/assets/images/upload/img_nav_lang.svg" width="14" height="14">
                            <img :src="require('@/assets/images/upload/img_nav_lang' + menu_icon_suffix +'.svg')" width="14" height="14" alt="">
                          </picture>
                          <span>{{ $t('Bao.switch_language') }}</span>
                          <i class="icon-keyboard_arrow_right" />
                        </a>
                        <ul class="lang-sub-container">
                          <a />
                          <li v-for="(item, key) in this.$store.state.brand.info.full_language" :key="key">
                            <a
                              class="d-flex align-items-center justify-content-between lang-item"
                              @click="changeLanguage(key)"
                            >{{ item }}</a>
                          </li>
                        </ul>
                      </li>
                      <!-- <li v-if="$store.getters.memberInfo && $store.getters.memberInfo.member_type != 0">
                        <a
                          class="d-flex align-items-center justify-content-between"
                          :href="$store.getters.urlInfo.agentUrl"
                        >
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_cooperate' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.agent_login') }}</span>
                        </a>
                      </li> -->
                      <li>
                        <a class="d-flex align-items-center justify-content-between" @click="logout">
                          <img
                            class="mw-100"
                            :src="require('@/assets/images/upload/img_nav_logout' + menu_icon_suffix + '.svg')"
                            width="14"
                            height="14"
                            alt=""
                          >
                          <span>{{ $t('Bao.logout') }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="sub_menu_area_reg d-flex align-items-center list-unstyled mb-0">
            <li id="js_reg_status" class="reg_status">
              <div class="reg_status_cont">
                <div class="reg_status_btn">
                  <div class="d-flex justify-content-around">
                    <button
                      v-if="!$store.getters.token"
                      class="btn btn_reg"
                      type="button"
                      data-toggle="modal"
                      data-target="#modal_register_box"
                      @click="$bvModal.show('modal_register_box')"
                    >
                      {{ $t("Bao.register") }}
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="sub_menu_area_len d-flex align-items-center list-unstyled mb-0">
            <li>
              <div class="top_bar_lang dropdown" :class="{'show': showLanguageDropdown}" @click="showLanguageDropdown = !showLanguageDropdown">
                <a
                  class="d-flex align-items-center dropdown-toggle"
                  role="button"
                >
                  <span>{{ selectedLanguage }}</span>
                </a>
                <div class="dropdown-menu border-0" :class="{'show': showLanguageDropdown}">
                  <a v-for="(item, key) in this.$store.state.brand.info.full_language" :key="key" class="dropdown-item d-flex align-items-center" @click="changeLanguage(key)">
                    <span>{{ item }}</span>
                  </a>
                </div>
              </div>
            </li>
          </ul>
          <ul class="sub_link_area d-grid align-items-center">
            <li class="d-lg-none">
              <div class="menu_area pr-0 w-auto ml-0">
                <div class="menu_list menu_sponsor">
                  <a class="menu_inner js_btn_dropdown p-0" @click="menuClickId('sponsor_mobile')">
                    <img class="m-0 mw-100" src="@/assets/images/upload/img_sponsor.webp" alt="">
                    <img class="m-0 mw-100" src="@/assets/images/upload/img_sponsor_hover.webp" alt="">
                  </a>
                  <a
                    v-if="banners[4] !== undefined"
                    id="sponsor_mobile"
                    class="menu_wrap menu_sponsor_inner p-0"
                    @click="menuClickId('sponsor_mobile')"
                  />
                </div>
              </div>
            </li>
            <template v-if="main_image.user_letter !== undefined && $store.getters.token">
              <li class="menu_area menu_area-right">
                <div class="menu_list">
                  <router-link class="menu_dropdown p-0" :to="main_image.user_letter[0].link">
                    <img class="mw-100 dot" :src="main_image.user_letter[0].image" alt="">
                    <small v-if="$store.state.user.unreadLetter" class="top-letter-notify" />
                    <span>{{ main_image.user_letter[0].name }}</span>
                  </router-link>
                </div>
              </li>
            </template>
            <template v-if="main_image.page_cooperation !== undefined">
              <template v-for="(item, key) in main_image.page_cooperation">
                <template>
                  <li :key="key" class="menu_area menu_area-right" @mouseover="handleOverId('page_cooperation_'+key)">
                    <div class="menu_list">
                      <template v-if="item.link == 'DailyBox'">
                        <a href="#!" class="menu_dropdown p-0" @click="showDailyBox">
                          <img class="mw-100" :src="item.image" alt="">
                          <span>{{ item.name }}</span>
                        </a>
                      </template>
                      <template v-else-if="item.open_type == 'new'">
                        <a
                          class="menu_dropdown p-0"
                          :target="newWindows(item)"
                          :href="item.link"
                          @click="menuClickId('page_cooperation_'+key)"
                        >
                          <img class="mw-100" :src="item.image" alt="">
                          <span>{{ item.name }}</span>
                        </a>
                        <template v-if="banners[key+5] !== undefined">
                          <a
                            :id="'page_cooperation_'+key"
                            class="menu_wrap menu_sponsor_inner p-0"
                            target="_blank"
                            :href="item.link"
                            @click="menuClickId('page_cooperation_'+key)"
                          >
                            <span :style="'background-image: url(\'' + banners[key+5].image + '\');'" />
                          </a>
                        </template>
                      </template>
                      <template v-else>
                        <router-link class="menu_dropdown p-0" :to="item.link" @click="menuClickId('page_cooperation_'+key)">
                          <img class="mw-100" :src="item.image" alt="">
                          <span>{{ item.name }}</span>
                        </router-link>
                        <template v-if="banners[key+5] !== undefined">
                          <router-link :id="'page_cooperation_'+key" class="menu_wrap menu_sponsor_inner p-0" :to="item.link" @click="menuClickId('page_cooperation_'+key)">
                            <template>
                              <span :style="'background-image: url(\'' + banners[key+5].image + '\');'" />
                            </template>
                          </router-link>
                        </template>
                      </template>
                    </div>
                  </li>
                </template>
              </template>
            </template>
          </ul>
          <div class="link_sponsor_area align-items-center">
            <div v-if="!$store.getters.token" class="login_status_btn">
              <div class="d-flex justify-content-around">
                <router-link
                  to="/user/login"
                  class="btn btn_login top-mobile-login d-block mobile"
                  type="button"
                >
                  {{ $t('Bao.login') }}
                </router-link>
              </div>
            </div>
            <template v-else>
              <div class="login_status_mwrap">
                <div class="login_status_flex">
                  <div class="login_status_img">
                    <img width="32" height="37" class="mw-100" :src="$store.getters.memberInfo.image" alt="">
                  </div>
                  <span class="login_status_info">
                    <h5 class="login_status_id">{{ $store.getters.name }}</h5>
                    <ul class="login_status_timely">
                      <li>
                        <h6 class="login_status_dolar">
                          <!--eslint-disable-next-line-->
                          <span v-html="$options.filters['numberFormat']($store.getters.gold)" />
                        </h6>
                      </li>
                      <li>
                        <button class="btn btn_reflash border-0 p-0" type="button">
                          <i class="icon-repeat login_status_reload" @click="refreshGold()" />
                        </button>
                      </li>
                    </ul>
                  </span>
                </div>
              </div>
              <a href=" " class="link_contact_block notice_icon_m">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.148" height="20.082" viewBox="0 0 18.148 20.082">
                  <g id="Group_1759" data-name="Group 1759" transform="translate(-1313 -50.41)">
                    <path
                      id="Path_1897"
                      data-name="Path 1897"
                      d="M10.9,1.882a5.172,5.172,0,0,1,2,.832,6.272,6.272,0,0,1,3.012,4.238,4.629,4.629,0,0,1,.116,1.339v.567c.074.338.008.718.089,1.047a11.208,11.208,0,0,0,.477,2,6.98,6.98,0,0,0,1.014,1.73c.26.374.708.629.895,1.041a1.319,1.319,0,0,1-.716,1.733,3.272,3.272,0,0,1-1.223.06H2.492a2.368,2.368,0,0,1-1.074-.06,1.467,1.467,0,0,1-.686-.626,1.694,1.694,0,0,1,0-1.166c.248-.372.638-.616.865-.981A6.285,6.285,0,0,0,2.638,11.9a9.264,9.264,0,0,0,.45-2,6.033,6.033,0,0,0,.089-1.047V8.291a11.938,11.938,0,0,1,.089-1.339A6.624,6.624,0,0,1,6.28,2.714a6.086,6.086,0,0,1,2.028-.832C8.308,1.115,8.486,0,9.56,0,10.689,0,10.9,1.078,10.9,1.882ZM9.2,3.162A4.1,4.1,0,0,0,5.554,5.215,4.442,4.442,0,0,0,4.7,7.758v.978l-.164,1.858a16.994,16.994,0,0,1-.789,2.8c-.265.6-.7,1.106-.987,1.663H16.506v-.033a8.764,8.764,0,0,1-1.612-3.553l-.263-1.662L14.6,8.834c-.066-.3.043-.74-.033-1.076l-.2-1.108C13.655,4.487,12.112,3.16,9.2,3.162ZM6.787,17.506H12.42A2.493,2.493,0,0,1,10.4,19.951a2.947,2.947,0,0,1-1.494.06A2.642,2.642,0,0,1,6.787,17.506Z"
                      transform="translate(1312.371 50.41)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <g
                      id="Ellipse_223"
                      data-name="Ellipse 223"
                      transform="translate(1324.391 53.556)"
                      fill="red"
                      stroke="#fff"
                      stroke-width="1.5"
                    >
                      <circle cx="2.629" cy="2.629" r="2.629" stroke="none" />
                      <circle cx="2.629" cy="2.629" r="3.379" fill="none" />
                    </g>
                  </g>
                </svg>
              </a>
            </template>
          </div>
        </div>
      </header>
    </div>
    <div class="main_area">
      <home-carousel v-if="isHome" />
      <div class="main_area_mbg">
        <div class="announcement-personal-provider">
          <div v-if="isHome" class="announcement_area media">
            <p class="mb-0">
              {{ $t('Bao.announcement') }}：
            </p>
            <div class="marquee">
              <span class="content">
                <span v-for="(item, key) in marquees" :key="key" class="announcement-item">
                  {{ item }}
                </span>
                <span class="content-space" />
              </span>
            </div>
          </div>
          <!-- <div v-if="isHome" class="float_personal_block m-10 d-lg-none d-block">
            <div class="d-flex align-items-center justify-content-between float_personal_content">
              <div class="float_personal_info">
                <template v-if="$store.getters.token">
                  <div class="d-flex">
                    <router-link to="/user">
                      <img class="mw-100 mr-15 personal_img" :src="$store.getters.memberInfo.image" alt="">
                    </router-link>
                    <div class="d-flex flex-column justify-content-center">
                      <p class="float_personal_id text-white mb-5" @click="$router.push('/user')">
                        <b>{{ $store.getters.name }}</b>
                      </p>
                      <div class="d-flex align-items-center">
                        <p class="float_personal_price text-white mr-5 mb-0">
                          eslint-disable
                          <span v-html="$options.filters['numberFormat']($store.getters.gold)" />
                        </p>
                        <i class="icon-repeat" @click="refreshGold()" />
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <router-link class="d-block" to="/user/login">
                    <p class="float_personal_title mb-5 text-white">{{ $t('Bao.you_not_login') }}</p>
                    <button class="btn_login">{{ $t('Bao.Login_register_now') }}</button>
                  </router-link>
                </template>
              </div>
              <ul class="float_personal_link d-flex list-unstyled mb-0">
                <li>
                  <router-link class="d-block" to="/payment/deposit">
                    <div class="float_personal_link-btn">
                      <div class="float_personal_link-icon">
                        <img src="@/assets/img/personal_deposit.svg" alt="">
                      </div>
                      <div class="float_personal_link-text">
                        Deposit
                      </div>
                    </div>

                  </router-link>
                </li>

              </ul>
            </div>
          </div> -->
          <div v-if="isHome" class="provider-container provider_m">
            <ul class="provider-content">
              <!-- <li class="provider-item search">
                <a href="javascript:void(0);">
                  <div class="provider-item-content">
                    <div class="provider-item-img">
                      <img src="@/assets/img/provider_search.svg" alt="">
                    </div>

                    <div class="provider-item-text">
                      <p>Search</p>
                    </div>
                  </div>
                </a>
              </li> -->
              <li class="provider-item providers">
                <a href="javascript:void(0);" @click="$bvModal.show('modal_provider')">

                  <div class="provider-item-content">

                    <div class="provider-item-img pc">

                      <img src="@/assets/img/provider/provider_providers.svg" alt="">

                    </div>
                    <div class="provider-item-img mobile">

                      <img src="@/assets/img/provider/provider_providers_mobile.svg" alt="">

                    </div>
                    <div class="provider-item-text">

                      <p>Providers</p>

                    </div>

                  </div>

                </a>
              </li>
              <li v-for="(item, key) in gameCategory" :key="key" class="provider-item provider-item-unit" :class="{ 'active': $route.query.category == item.id }">
                <router-link :to="'/index?category=' + item.id">
                  <div class="provider-item-content">
                    <div class="provider-item-img">
                      <img :src="item.image" alt="">
                    </div>

                    <div class="provider-item-text">
                      <p>{{ item.name }}</p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>

            <div class="provider-arrow provider-left">
              <div class="provider-left-icon">
                <img src="@/assets/img/provider_arrow.svg" alt="">
              </div>
            </div>

            <div class="provider-arrow provider-right">
              <div class="provider-right-icon">
                <img src="@/assets/img/provider_arrow.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tab-provider_flex" class="tab-provider_flex" :class="{ 'open_tab': isOpenTab }">
        <div id="provider" class="tab-provider tab-provider-index" :class="{ 'open_tab': isOpenTab }">
          <div v-if="$route.name === 'Index' || $route.name === 'GameProvider'" class="tab-mark" @click="toogleTab">
            <p>PROVIDER</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.886" height="5.622" viewBox="0 0 8.886 5.622">
              <g id="Group_2044" data-name="Group 2044" transform="translate(7.613 4.35) rotate(180)">
                <line id="Line_62" data-name="Line 62" x2="4.351" transform="rotate(45)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.8" />
                <line id="Line_63" data-name="Line 63" x2="4.351" transform="translate(6.34 0) rotate(135)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.8" />
              </g>
            </svg>
          </div>
          <div class="tab-container_outer">
            <div class="tab-container">
              <div v-for="(item, key) in gameProvider" :key="key" class="tab-item" @click="$router.push('/game/provider/' + item.game_provider_id)">
                <img :src="item.image_h5">
              </div>
            </div>
          </div>
        </div>
        <div />
        <div class="main_area_sub d-grid">
          <main v-if="$store.getters.gameType" class="main_inner flex-grow-1">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </main>
          <main v-else class="main_inner flex-grow-1 loading" />
          <rank-list type="app" :parent-show-off-game-bets="showOffGameBets" />
          <aside class="aside_area right">
            <div class="aside_inner d-grid">
              <div class="adimg_area d-grid">
                <rank-list type="web" :parent-show-off-game-bets="showOffGameBets" />
                <!-- <a v-if="banners[2] !== undefined" class="d-block" :href="banners[2].link" :target="banners[2].open_type">
                  <img class="mw-100" :src="banners[2].image" alt="">
                </a> -->
                <a v-if="banners[3] !== undefined" class="d-block" :href="banners[3].link" :target="banners[3].open_type">
                  <img class="mw-100" :src="banners[3].image" alt="">
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
    <div class="footer-content">
      <footer class="footer_area d-none d-lg-block">
        <div class="footer_wrap">
          <div class="footer_line">
            <template v-if="this.$store.getters.permissionInfo.enable_footer">
              <template v-if="main_image.sponsor_footer !== undefined">
                <ul class="footer_sponsor">
                  <li v-for="(item, key) in main_image.sponsor_footer" :key="key">
                    <a class="d-block" :href="item.link" :target="newWindows(item)"><img class="mw-100" :src="item.image" height="40" alt=""></a>
                  </li>
                </ul>
              </template>
            </template>
            <!-- <div class="footer_lic">
              <div id="apg-9084d613-1bff-41cb-bb8c-51bfad53745b" data-apg-seal-id="9084d613-1bff-41cb-bb8c-51bfad53745b" data-apg-image-size="256" data-apg-image-type="basic-light-large"></div>
            </div> -->
            <ul class="footer_bottons_container">
              <li>
                <router-link to="/page/about">
                  {{ $t('Bao.about_us') }}
                </router-link>
              </li>
              <li>
                <router-link to="/page/rule">
                  {{ $t('Bao.rule') }}
                </router-link>
                <span>
                  <a target="_blank" href="https://cga.bonus365.io/Terms%20and%20Conditions%20of%20Use_.docx">
                    <img src="@/assets/img/icon_download.svg" height="10" alt="">
                  </a>
                </span>
              </li>
              <li>
                <router-link to="/page/privacy">
                  {{ $t('Bao.privacy') }}
                </router-link>
              </li>
              <li>
                <router-link to="/page/agent">
                  {{ $t('Bao.agent_rule') }}
                </router-link>
              </li>
              <li>
                <router-link to="/page/terms">
                  {{ $t('Bao.member_terms') }}
                </router-link>
              </li>
            </ul>
            <template v-if="this.$store.getters.permissionInfo.enable_follow">
              <template v-if="main_image.follow_media !== undefined">
                <ul class="footer_social">
                  <li v-for="(item, key) in main_image.follow_media" :key="key">
                    <a class="d-flex rounded-circle" :href="item.link" :target="newWindows(item)"><img
                      class="rounded-circle mw-100"
                      :src="item.image"
                      width="26"
                      height="26"
                      alt=""
                    ></a>
                  </li>
                </ul>
              </template>
            </template>
          </div>
          <p>
            {{ footerIntro }}
          </p>
        </div>
      </footer>
    </div>
    <template v-if="brandPermissions.seo_enable">
      <div class="footer-seo">
        <p>{{ brandPermissions.seo_title }}<span><img src="@/assets/img/arrow-down.svg" alt=""></span></p>
      </div>
      <div class="footer-seo-content">
        <p class="quote">
          {{ brandPermissions.seo_title }}
        </p>
        <!-- eslint-disable -->
        <p v-html="brandPermissions.seo_content" />
      </div>
    </template>
    <announcement-modal />
    <login-modal />
    <register-modal />
    <game-providers-modal ref="gameProvidersModal" />
    <float-ad-banner :banners="banners" />
    <float-game-type @selectGameType="selectGameType" />
    <quick-bar />
    <slide-notice v-if="$route.name === 'Index'" />
  </div>
</template>

<script>
// eslint-disable-next-line
import { newWindows } from '@/utils/tool'
import { getTypeMenuInfo, getCategory, getShowOffGameBets, getGames } from '@/api/game'
import { refreshGold, detectMob } from '@/utils/tool'
import { getBanner, getBrandGameProviderSidebar } from '@/api/brand'
import { providerLink } from '@/utils/games'
import { page, getLastChatMessage } from '@/api/common'
import { logout as localLogout } from '@/utils/user'
import announcementModal from '@/components/modal/announcementModal'
import loginModal from '@/components/modal/loginModal'
import gameProvidersModal from '@/components/modal/gameProvidersModal'
import homeCarousel from '@/components/homeCarousel'
import i18n from '@/i18n'
import { getMarquee } from '@/api/brand'
import registerModal from '@/components/modal/registerModal'
import floatAdBanner from '@/components/floatAdBanner'
import floatGameType from '@/components/floatGameType'
import quickBar from '@/components/quickBar'
import slideNotice from '@/components/slideNotice'
import rankList from '@/components/rankList'
import $ from 'jquery'
import { loadDynamicCss } from '@/utils/tool'
import { providerSlide, startMarquees, handleTabProviderFix } from '@/utils/customJquery'
import Cookies from 'js-cookie'

export default {
  name: 'Main',
  components: {
    announcementModal,
    homeCarousel,
    loginModal,
    registerModal,
    gameProvidersModal,
    floatAdBanner,
    quickBar,
    floatGameType,
    slideNotice,
    rankList
  },
  data() {
    return {
      banners: [],
      langString: '',
      icon_chat_path: require('@/assets/images/icon_chat_en.webp'),
      footerIntro: null,
      footerCs: null,
      slideLeftDisabled: true,
      slideRightDisabled: false,
      marquees: [],
      carousel: [],
      csUrl: '',
      showMobileAppDownload: true,
      deposit_word: '',
      mobileNavMore: false,
      follow_media: null,
      follow_qrcode: null,
      sponsor_footer: null,
      isHome: true,
      main_image: null,
      gameCategory: [],
      selectedLanguage: '',
      showLanguageDropdown: false,
      isOpenTab: false,
      gameProvider: [],
      showOffGameBets: []
    }
  },
  computed: {
    brandPermissions() {
      return this.$store.getters.permissionInfo
    },
    menu_icon_suffix() {
      if (detectMob() && this.$store.getters.brand.theme === 'theme1') return '-w'
      else return ''
    },
    theme() {
      return this.$store.getters.brand.theme
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.path === '/index') {
        document.body.id = 'index'
      } else {
        document.body.id = ''
      }
      setTimeout(() => {
        if (to.name === 'Index') this.isHome = true
        else this.isHome = false
      }, 10)
    }
  },
  created() {
    if (this.$route.name === 'Index') {
      document.body.id = 'index'
    } else {
      document.body.id = ''
    }
    loadDynamicCss(this.$store.getters.brand.theme)
    if (this.$route.name === 'Index') this.isHome = true
    else this.isHome = false
    this.deposit_word = i18n.t('Bao.do_deposit')
    if (i18n.locale === 'zh') {
      this.icon_chat_path = require('@/assets/images/icon_chat.svg')
      const word = i18n.t('Bao.do_deposit')
      this.deposit_word = word.slice(0, 1) + '<br />' + word.slice(1)
    }
    this.langString = i18n.locale
    // 重取gameType
    this.$store.commit('SET_GAME_TYPE', null)
    getTypeMenuInfo().then((response) => {
      this.$store.commit('SET_GAME_TYPE', response.data.data)
      this.$nextTick(() => {
        providerSlide()
      })
    })

    this.$store.commit('SET_GAME_CATEGORY', null)
    getCategory().then((response) => {
      this.gameCategory = response.data.data
      this.$store.commit('SET_GAME_CATEGORY', response.data.data)
    })

    if (this.$store.state.brand.brandImage !== null) {
      this.main_image = this.$store.state.brand.brandImage
    }
    getBanner().then(response => {
      this.banners = response.data.data
    })

    getMarquee().then(response => {
      this.marquees = response.data.data
      this.$nextTick(() => {
        startMarquees()
      })
    })

    getGames().then((response) => {
      const allGame = response.data.data
      this.handleShowOffGameBets(allGame)
      setInterval(() => {
        this.handleShowOffGameBets(allGame)
        // this.showOffGameBets.splice(2, 1, {
        //   id: 10,
        //   member_nickname: '123',
        //   game_name: 'aaaa',
        //   bet_result: 10.1
        // })
        // this.showOffGameBets.splice(5, 1, {
        //   id: 10,
        //   member_nickname: '1232',
        //   game_name: 'bbbb',
        //   bet_result: 1000.1
        // })
      }, 60000)
    })

    getBrandGameProviderSidebar().then((response) => {
      this.gameProvider = response.data.data
    })

    let currentLangKey = ''
    if (this.$route.query.language) {
      currentLangKey = this.$route.query.language
    } else if (Cookies.get('language')) {
      currentLangKey = Cookies.get('language')
    } else {
      currentLangKey = 'zh'
    }
    for (const i in this.$store.state.brand.info.full_language) {
      if (i === currentLangKey) {
        this.selectedLanguage = this.$store.state.brand.info.full_language[i]
      }
    }

    if (this.$store.getters.token) {
      // 開啟socket
      this.$socket.init()
    }
    setInterval(() => {
      this.setLastChatMessage()
    }, 60000)

    page({ type: 'footer_intro' }).then(response => {
      this.footerIntro = response.data.data.content
    })
    page({ type: 'footer_cs' }).then(response => {
      this.footerCs = response.data.data.content
    })

    // 偵測iframe聊天事件
    window.addEventListener('message', this.chatRoomEvent, false)
    // page({ type: 'footer_cs' }).then(response => {
    //   this.footerCs = response.data.data.content
    // })
    if (this.$store.state.brand.urlInfo.csUrl !== null) {
      this.csUrl = this.$store.state.brand.urlInfo.csUrl
    } else {
      this.csUrl = 'https://kiifssbyt.chatnow.mstatik.com/widget/standalone.html?eid=1515bdfbfd2280309775d317c9901c9e'
    }
  },
  mounted() {
    if (!this.$store.getters.readAnnouncement && this.$store.getters.permissionInfo.enable_pop_announcement) {
      if (this.$route.path === '/index') {
        this.$bvModal.show('modal_news')
      }
    }

    /* 切版的 js + jquery */

    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('CriOS') > -1
    var is_safari = navigator.userAgent.indexOf('Safari') > -1
    if ((is_chrome) && (is_safari)) { is_safari = false }

    if (is_safari) {
      if (window.innerWidth < 991) {
        $('html, body').addClass('safari')
        $('.header-content').addClass('mobile')
      } else {
        $('.header-content').removeClass('mobile')
      }
    }
    if (is_chrome) {
      if (window.innerWidth < 991) {
        $('.header-content').addClass('mobile')
      } else {
        $('.header-content').removeClass('mobile')
      }
    }
    $('.footer-seo').click(function() {
      $('.footer-seo-content').slideToggle('slow')
      $('.footer-seo').toggleClass('active')
    })
    $('.menu_list').mouseenter(function() {
      $('.header-content').addClass('menu_resize')
    })
    $('.menu_list').mouseleave(function() {
      $('.header-content').removeClass('menu_resize')
    })
    var self = this
    $(window).scroll(function() {
      var scroll = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
      if (window.innerWidth >= 992) {
        $('.header-content').removeClass('mobile')
        if (scroll >= 30) {
          $('.header-content').addClass('fixed')
        } else {
          $('.header-content').removeClass('fixed')
        }
      } else if (window.innerWidth < 991) {
        $('.header-content').addClass('mobile')
        if (!$('.mobile_app_download').hasClass('close-already')) {
          if (scroll >= 54) {
            $('.header-content').addClass('fixed')
            $('.main_area').addClass('header-fixed')
            $('.sub_member_list').addClass('header-fixed')
          } else if (scroll < 54) {
            $('.header-content').removeClass('fixed')
            $('.main_area').removeClass('header-fixed')
            $('.sub_member_list').removeClass('header-fixed')
          }
        } else if ($('.mobile_app_download').hasClass('close-already')) {
          $('.header-content').addClass('fixed')
          $('.main_area').addClass('header-fixed')
          $('.sub_member_list').addClass('header-fixed')
        }
      }
    })

    $(window).resize(function() {
      if (window.innerWidth >= 992) {
        $('.header-content').removeClass('mobile')
        if (scroll >= 30) {
          $('.header-content').addClass('fixed')
        } else {
          $('.header-content').removeClass('fixed')
        }
      } else if (window.innerWidth < 991) {
        $('.header-content').addClass('mobile')
        if (!$('.mobile_app_download').hasClass('close-already')) {
          if (scroll >= 54) {
            $('.header-content').addClass('fixed')
            $('.main_area').addClass('header-fixed')
            $('.sub_member_list').addClass('header-fixed')
          } else if (scroll < 54) {
            $('.header-content').removeClass('fixed')
            $('.main_area').removeClass('header-fixed')
            $('.sub_member_list').removeClass('header-fixed')
          }
        } else if ($('.mobile_app_download').hasClass('close-already')) {
          $('.header-content').addClass('fixed')
          $('.main_area').addClass('header-fixed')
          $('.sub_member_list').addClass('header-fixed')
        }
      }
    })

    $('.mobile-nav-item.more').click(function() {
      if ($('.header-content').hasClass('fixed')) {
        $('.sub_menu_area').addClass('close-already')
      } else if (!$('.header-content').hasClass('fixed')) {
        $('.sub_menu_area').removeClass('close-already')
      }
      if (!self.mobileNavMore) {
        $('.sub_menu_area').show()
        $('.sub_menu_area').stop().animate({ 'right': 0 }, 100)
        $(this).addClass('active')
        $('html, body').addClass('scrollfixed')
        self.mobileNavMore = true
      } else if (self.mobileNavMore) {
        $('.sub_menu_area').stop().animate({ 'right': '-260px' }, 100, function() {
          $('.sub_menu_area').hide()
        })
        $(this).removeClass('active')
        $('html, body').removeClass('scrollfixed')
        self.mobileNavMore = false
      }
    })
    $('.sub_menu_area').find('a').not('.lang-switch').click(function() {
      self.closeMenu()
    })
    $('.sub_menu_area').find('button').click(function() {
      self.closeMenu()
    })
    $('.sub_menu_area').find('h5').click(function() {
      self.closeMenu()
    })
    $('.sub_menu_area').find('img').click(function() {
      self.closeMenu()
    })
    $('.lang-switch').click(function() {
      $('.lang-switch').toggleClass('active')
      $('.lang-sub-container').slideToggle()
    })

    handleTabProviderFix()
    // eslint-disable-next-line
    // apg_9084d613_1bff_41cb_bb8c_51bfad53745b.init()
  },
  destroyed() {
    console.log('main destroyed')
  },
  methods: {
    handleOver(key) {
      var el = document.querySelectorAll('.menu_wrap')
      el[key].style.display = 'block'
      $('.header-content').addClass('menu_resize')
    },
    handleLeave() {
      $('.header-content').removeClass('menu_resize')
    },
    handleOverId(id) {
      if (detectMob()) {
        return
      }
      var el = document.getElementById(id)
      if (el) {
        el.style.display = 'block'
      }
    },
    goProvider(provider) {
      if (!this.$store.getters.token) {
        this.$bvModal.show('modal_login_box')
      } else {
        providerLink(provider)
      }
    },
    menuClick(key) {
      var el = document.querySelectorAll('.menu_wrap')
      el[key].style.display = 'none'
    },
    menuClickId(item) {
      var el = document.getElementById(item)
      if (el) {
        el.style.display = 'none'
      }

      if (item instanceof String) {
        if (item === 'sponsor') {
          this.$router.push('/page/partner').catch(() => { })
        } else if (item === 'sponsor_mobile') {
          this.$router.push('/page/partner').catch(() => { })
        } else if (item === 'vip') {
          this.$router.push('/vip').catch(() => { })
        } else if (item === 'event') {
          this.$router.push('/event').catch(() => { })
        }
      }
    },
    handleOverSubMenu() {
      var el = document.querySelectorAll('.sub_member_menu_wrap')
      el[0].style.display = 'block'
    },
    refreshGold() {
      refreshGold()
    },
    newWindows(obj) {
      return newWindows(obj)
    },
    isShowMenu() {
      if ((this.$route.meta.needLogin !== undefined && this.$route.meta.needLogin) || (this.$store.getters.token && this.$route.name !== 'Index')) return true
      else return false
    },
    // isHome() {
    //   setTimeout(() => {
    //     if (this.$route.name === 'Index') return true
    //     else return false
    //   }, 10)
    // },
    isVip() {
      if (this.$route.path === '/vip') {
        return true
      } else return false
    },
    isAgent() {
      if (this.$store.getters.memberInfo.memberType === 1 || this.$store.getters.memberInfo.memberType === 2) return true
      else return false
    },
    logout() {
      localLogout()
    },
    change_lang() {
      const support_lang = JSON.parse(JSON.stringify(this.$store.getters.supportLanguages))
      const index = support_lang.indexOf(this.$store.getters.language)
      if (index > -1) {
        support_lang.splice(index, 1)
      }
      var url = new URL(document.location.href)
      url.searchParams.set('language', support_lang[0])
      document.location.href = url
    },
    slideLeft() {
      const el = document.querySelector('.menu_wrapper')
      el.scrollLeft -= 40
      this.checkButtonStatus(el)
    },
    slideRight() {
      const el = document.querySelector('.menu_wrapper')
      el.scrollLeft += 40
      this.checkButtonStatus(el)
    },
    checkButtonStatus(el) {
      const maxScrollLeft = el.scrollWidth - el.clientWidth
      if (el.scrollLeft === 0) {
        this.slideLeftDisabled = true
      } else {
        this.slideLeftDisabled = false
      }
      if (maxScrollLeft <= el.scrollLeft) {
        this.slideRightDisabled = true
      } else {
        this.slideRightDisabled = false
      }
    },
    setLastChatMessage() {
      getLastChatMessage().then(response => {
        const uuid = response.data.data.uuid
        if (this.$store.state.user.lastChatMessage.uuid !== uuid || !this.$store.state.user.lastChatMessage.read) {
          this.$store.commit('SET_LAST_CHAT_MESSAGE', {
            uuid: response.data.data.uuid,
            read: false
          })
        }
      })
    },
    getChatSrc() {
      let charSrc = this.$store.getters.urlInfo.websocketChatUrl
      if (charSrc && this.$store.getters.token) {
        charSrc += '&token=' + this.$store.getters.token
      }

      return charSrc
    },
    enterChat() {
      this.$store.commit('SET_LAST_CHAT_MESSAGE', {
        uuid: this.$store.state.user.lastChatMessage.uuid,
        read: true
      })
    },
    closeMenu() {
      $('.sub_menu_area').stop().animate({ 'right': '-260px' }, 100, function() {
        $('.sub_menu_area').hide()
      })
      $('.mobile-nav-item.more').removeClass('active')
      $('html, body').removeClass('scrollfixed')
      this.mobileNavMore = false
    },
    goLogin() {
      if (!detectMob()) this.$bvModal.show('modal_login_box')
      else this.$router.push('/user/login')
    },
    changeLanguage(key) {
      for (const i in this.$store.state.brand.info.full_language) {
        if (i === key) {
          this.selectedLanguage = this.$store.state.brand.info.full_language[i]
        }
      }
      var url = new URL(document.location.href)
      url.searchParams.set('language', key)
      document.location.href = url
    },
    goMobileAppDownload() {
      window.open(this.$store.getters.urlInfo.appDownloadUrl)
    },
    selectGameType(gameType) {
      this.$bvModal.show('modal_provider')
      this.$refs.gameProvidersModal.selectGameType(gameType)
    },
    toogleTab() {
      this.isOpenTab = !this.isOpenTab
    },
    handleShowOffGameBets(allGame) {
      getShowOffGameBets().then((response) => {
        this.showOffGameBets = response.data.data
        for (const i in this.showOffGameBets) {
          for (const j in allGame) {
            if (allGame[j].id === this.showOffGameBets[i].game_id) {
              this.$set(this.showOffGameBets[i], 'game_name', allGame[j].name)
            }
          }
        }
      })
    },
    showDailyBox() {
      if (this.$store.getters.token) {
        this.$bvModal.show('modal_daily_box')
      } else {
        this.$bvModal.show('modal_login_box')
      }
    }
  }
}
</script>

<style>
.sitemessage {
  height: 18px;
  line-height: 18px;
  display: inline-block;
  white-space: nowrap;
  animation: floatText 50s infinite linear;
  padding-left: 100%;
  /*Initial offset*/
}

.sitemessage:hover {
  color: white;
  animation-play-state: paused;
}

.four_nav {
  grid-template-columns: repeat(4, 1fr);
}

.mobile_app_download {
  padding: 4px 20px;
}

.mobile_nav_block .nav_items {
  padding: 7px 0 4px;
}

.mobile_nav_block>li.center .nav_items img {
  transform: scale(1.9);
}

.mobile_nav_block>li.center .nav_items.logo-nav img {
  top: -7px;
  transform: scale(1.8);
}

@keyframes floatText {
  to {
    transform: translateX(-100%);
  }
}

.personal_img {
  max-width: 3.125em;
  max-height: 3.125em;
}

.top-letter-notify {
  position: absolute;
  height: 10px;
  width: 10px;
  background-color: #ff0000;
  display: block;
  top: -1px;
  right: 8px;
  border-radius: 50%;
  border: 1px solid white;
}

.wrap-license {
  width: 80px;
  margin-top: 10px;
}
</style>
